import AcquireTokenCallback from './schema/AcquireTokenCallback';
import AdalErrorCode from './schema/AdalErrorCode';
import acquireTokenFromAuthContext from './utils/acquireTokenFromAuthContext';
import { lazyCreateAdalAuthenticationContext } from 'owa-adal-angular';
import getAuthenticationUrl from './utils/getAuthenticationUrl';
import loginUserAndAcquireToken from './utils/loginUserAndAcquireToken';

export async function getAccessTokenOnBehalfOfResource(
    clientId: string,
    redirectUri: string,
    resource: string,
    authChallenge: string,
    allowConsentPrompt: boolean,
    allowSignInPrompt: boolean,
    getAccessTokenCallback: AcquireTokenCallback
): Promise<void> {
    const authUrl = getAuthenticationUrl();
    const authContext = await lazyCreateAdalAuthenticationContext.importAndExecute(
        authUrl,
        clientId,
        redirectUri
    );
    const user = authContext.getCachedUser();
    if (user) {
        acquireTokenFromAuthContext(
            authContext,
            resource,
            authChallenge,
            allowConsentPrompt,
            getAccessTokenCallback
        );
    } else if (allowSignInPrompt) {
        loginUserAndAcquireToken(
            authContext,
            resource,
            authChallenge,
            allowConsentPrompt,
            getAccessTokenCallback
        );
    } else {
        // there is no cachedUser in authContext and allowSignInPrompt is false.
        getAccessTokenCallback(AdalErrorCode.NoPreAuth, undefined);
    }
}
